import { unsetAuthData } from 'app/slice/authSlice';
import store from 'app/store';
import { VI_LANG } from 'constants/global';
import keycloak from '../../keycloak';
import Swal from 'sweetalert2';
import capacityUsedApi from 'api/capacityUsedApi';

const getMessage401 = (lang, message) => {
    if (lang === VI_LANG) {
        Swal.fire({
            title: 'Thất bại',
            text: message,
            icon: 'error',
            dangerMode: false,
            showConfirmButton: false,
            showDenyButton: true,
            denyButtonText: `Đăng xuất`,
        }).then((result) => {
            if (result.isDenied) {

                store.dispatch(unsetAuthData());
                keycloak.logout();
            }
        });
    } else {
        Swal.fire({
            title: 'Fail',
            text: message,
            icon: 'error',
            dangerMode: false,
            showConfirmButton: false,
            showDenyButton: true,
            denyButtonText: `Logout`,
        }).then((result) => {
            if (result.isDenied) {

                store.dispatch(unsetAuthData());
                keycloak.logout();
            }
        });
    }
};
export default getMessage401;
